import { Manager } from '$synapse/models';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { genericBaseUrl } from './utils';
import { ManagerDto } from '$synapse/dtos';

@Injectable({
  providedIn: 'root',
})
export class ManagerService {
  private readonly _keycloakService = inject(KeycloakService);
  private readonly _http = inject(HttpClient);

  baseUrl(...path: any[]): string {
    return genericBaseUrl(`${environment.settings.api.url}/manager`, ...path);
  }

  fetchProfile(): Observable<Manager> {
    return from(
      this._keycloakService
        .getKeycloakInstance()
        .loadUserInfo()
        .then((user) => new Manager(user as ManagerDto))
    );
  }

  updateManager(manager: Manager) {
    return this._http.patch<Manager>(this.baseUrl(manager.id), manager);
  }
}
